import {
    SCREEN_NAME,
    CLICK_ACTIONS,
    SCREEN_VIEW_ACTIONS,
    IMPRESSION_ACTIONS,
} from "@payment-client/analytics/constants";
import { AnalyticsContextValue, GlobalHeaderState, SwgyHeaderKeysList } from "@swiggy-private/checkout-core";
import { convertObjToString } from "@swiggy-private/core-ui";

export const paymentFailedDialogScreenViewEvent = (screenViewEvent: AnalyticsContextValue["screenViewEvent"]): void => {
    screenViewEvent({
        category: SCREEN_NAME.PAYMENT_FAILURE_DIALOG,
        context: convertObjToString({
            marketplaceBusinessLine: GlobalHeaderState.getHeader(SwgyHeaderKeysList.marketplaceBusinessLine) || "",
            marketplaceCategory: GlobalHeaderState.getHeader(SwgyHeaderKeysList.marketplaceCategory) || "",
        }),
    });
};

export const paymentFailedDialogTryOtherClickEvent = (clickEvent: AnalyticsContextValue["clickEvent"]): void => {
    clickEvent({
        category: SCREEN_NAME.PAYMENT_FAILURE_DIALOG,
        action: CLICK_ACTIONS.CLICK_PAYMENT_FAILURE_DIALOG_TRY_OTHER_PAYMENT,
    });
};

export const paymentFailedDialogDismissClickEvent = (clickEvent: AnalyticsContextValue["clickEvent"]): void => {
    clickEvent({
        category: SCREEN_NAME.PAYMENT_FAILURE_DIALOG,
        action: CLICK_ACTIONS.CLICK_PAYMENT_FAILURE_DIALOG_DISMISS_PAYMENT,
    });
};

export const paymentFailedDialogRetryClickEvent = (clickEvent: AnalyticsContextValue["clickEvent"]): void => {
    clickEvent({
        category: SCREEN_NAME.PAYMENT_FAILURE_DIALOG,
        action: CLICK_ACTIONS.CLICK_PAYMENT_FAILURE_DIALOG_RETRY_PAYMENT,
    });
};

// autopay/pay on delivery events
export const autoPayEligiblePaymentFailureScreenEvent = (
    screenViewEvent: AnalyticsContextValue["screenViewEvent"],
    cartAmount: number,
    failureReason: string,
): void => {
    screenViewEvent({
        category: SCREEN_NAME.AUTOPAY_PAYMENT_FAILURE_SCREEN,
        action: SCREEN_VIEW_ACTIONS.VIEW_AUTOPAY_PAYMENT_FAILURE_SCREEN,
        context: String(cartAmount),
        label: failureReason || "-",
    });
};

export const autopayAutoplaceGotoTrackClickEvent = (
    clickEvent: AnalyticsContextValue["clickEvent"],
    cartAmount: number,
): void => {
    clickEvent({
        category: SCREEN_NAME.AUTOPAY_PAYMENT_FAILURE_SCREEN,
        action: CLICK_ACTIONS.CLICK_PAY_ON_NEXT_SCREEN,
        context: String(cartAmount),
    });
};

export const autopayAutoplacePlaceOrderPayOnNextScreenClickEvent = (
    clickEvent: AnalyticsContextValue["clickEvent"],
    cartAmount: number,
): void => {
    clickEvent({
        category: SCREEN_NAME.AUTOPAY_PAYMENT_FAILURE_SCREEN,
        action: CLICK_ACTIONS.CLICK_PLACE_ORDER_PAY_ON_NEXT_SCREEN,
        context: String(cartAmount),
    });
};

export const autopayAutoplaceGoBackClickEvent = (
    clickEvent: AnalyticsContextValue["clickEvent"],
    cartAmount: number,
): void => {
    clickEvent({
        category: SCREEN_NAME.AUTOPAY_PAYMENT_FAILURE_SCREEN,
        action: CLICK_ACTIONS.CLICK_GO_BACK,
        context: String(cartAmount),
    });
};

export const autopaySubtleConsentCancelClickEvent = (
    clickEvent: AnalyticsContextValue["clickEvent"],
    cartAmount: number,
) => {
    clickEvent({
        category: SCREEN_NAME.AUTOPAY_PAYMENT_FAILURE_SCREEN,
        action: CLICK_ACTIONS.CLICK_CANCEL,
        context: String(cartAmount),
    });
};

export const upiPaymentFailedImpressionEvent = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    context: Record<string, string | number | undefined>,
) => {
    impressionEvent({
        category: SCREEN_NAME.PAYMENT,
        action: IMPRESSION_ACTIONS.IMPRESSION_UPI_INTENT_PAYMENT_FAILED,
        context: JSON.stringify(context),
    });
};
